import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[stopPropagation]',
  standalone:true
})
export class StopPropagationDirective {
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.stopPropagation();
  }


  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    event.stopPropagation();
  }

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    event.stopPropagation();
  }


  @HostListener('focus', ['$event'])
  onFocus(event: Event): void {
    event.stopPropagation();
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    event.stopPropagation();
  }
}
